import {ParameterType, Task} from 'analyses/primers/PrimerWizardConstants';

export interface PrimerWizardTask {
  task: Task;
  default: string | number | null;
}

export interface PrimerWizardParams {
  label: string;
  placeholder?: string | number;
  default: string | number | null;
  type: ParameterType;
  tasks?: Array<PrimerWizardTask>;
}

interface PrimerWizardKeyVals {
  [key: string]: PrimerWizardParams;
}

// The defaults are currently not correct...

const PRIMER_WIZARD_PARAMS: PrimerWizardKeyVals = {
  PICK_INTERNAL: {
    label: 'PRIMER_PICK_INTERNAL_OLIGO',
    type: ParameterType.BOOL,
    tasks: [{task: Task.QPCR_PROBE, default: 'true'}],
    default: null,
  },
  TARGET_START: {
    label: 'region-start',
    placeholder: 'Start',
    type: ParameterType.START_INDEX,
    default: null,
  },
  TARGET_END: {
    label: 'region-end',
    placeholder: 'End',
    type: ParameterType.END_INDEX,
    default: null,
  },
  INCLUDED_START: {
    label: 'SEQUENCE_START_INCLUDED_REGION',
    placeholder: 'Start',
    type: ParameterType.START_INDEX,
    default: null,
  },
  INCLUDED_END: {
    label: 'SEQUENCE_END_INCLUDED_REGION',
    placeholder: 'End',
    type: ParameterType.END_INDEX,
    default: null,
  },
  EXCLUDED_REGION: {
    label: 'SEQUENCE_EXCLUDED_REGION',
    placeholder: 'e.g. 1-200,175-300',
    type: ParameterType.INTERVAL_LIST,
    default: null,
  },
  EXCLUDED_PROBE_REGION: {
    label: 'SEQUENCE_INTERNAL_EXCLUDED_REGION',
    placeholder: 'e.g. 1-200,175-300',
    type: ParameterType.INTERVAL_LIST,
    tasks: [{task: Task.QPCR_PROBE, default: null}],
    default: null,
  },
  GC_MIN: {
    label: 'PRIMER_MIN_GC',
    default: 35,
    type: ParameterType.FLOAT,
  },
  GC_OPT: {
    label: 'PRIMER_OPT_GC',
    default: 50,
    type: ParameterType.FLOAT,
  },
  GC_MAX: {
    label: 'PRIMER_MAX_GC',
    default: 65,
    type: ParameterType.FLOAT,
  },
  TM_MIN: {
    label: 'PRIMER_MIN_TM',
    default: 55,
    type: ParameterType.FLOAT,
  },
  TM_OPT: {
    label: 'PRIMER_OPT_TM',
    default: 62,
    type: ParameterType.FLOAT,
  },
  TM_MAX: {
    label: 'PRIMER_MAX_TM',
    default: 65,
    type: ParameterType.FLOAT,
  },
  SIZE_MIN: {
    label: 'PRIMER_MIN_SIZE',
    default: 18,
    type: ParameterType.NUMBER,
  },
  SIZE_OPT: {
    label: 'PRIMER_OPT_SIZE',
    default: 22,
    type: ParameterType.NUMBER,
  },
  SIZE_MAX: {
    label: 'PRIMER_MAX_SIZE',
    default: 26,
    type: ParameterType.NUMBER,
  },
  GC_CLAMP: {
    label: 'PRIMER_GC_CLAMP',
    placeholder: 0,
    type: ParameterType.NUMBER,
    default: null,
  },
  GC_PROBE_MIN: {
    label: 'PRIMER_INTERNAL_MIN_GC',
    type: ParameterType.FLOAT,
    tasks: [{task: Task.QPCR_PROBE, default: 35}],
    default: null,
  },
  GC_PROBE_OPT: {
    label: 'PRIMER_INTERNAL_OPT_GC',
    type: ParameterType.FLOAT,
    tasks: [{task: Task.QPCR_PROBE, default: 50}],
    default: null,
  },
  GC_PROBE_MAX: {
    label: 'PRIMER_INTERNAL_MAX_GC',
    type: ParameterType.FLOAT,
    tasks: [{task: Task.QPCR_PROBE, default: 65}],
    default: null,
  },
  TM_PROBE_MIN: {
    label: 'PRIMER_INTERNAL_MIN_TM',
    type: ParameterType.FLOAT,
    tasks: [{task: Task.QPCR_PROBE, default: 55}],
    default: null,
  },
  TM_PROBE_OPT: {
    label: 'PRIMER_INTERNAL_OPT_TM',
    type: ParameterType.FLOAT,
    tasks: [{task: Task.QPCR_PROBE, default: 62}],
    default: null,
  },
  TM_PROBE_MAX: {
    label: 'PRIMER_INTERNAL_MAX_TM',
    type: ParameterType.FLOAT,
    tasks: [{task: Task.QPCR_PROBE, default: 65}],
    default: null,
  },
  SIZE_PROBE_MIN: {
    label: 'PRIMER_INTERNAL_MIN_SIZE',
    type: ParameterType.NUMBER,
    tasks: [{task: Task.QPCR_PROBE, default: 18}],
    default: null,
  },
  SIZE_PROBE_OPT: {
    label: 'PRIMER_INTERNAL_OPT_SIZE',
    type: ParameterType.NUMBER,
    tasks: [{task: Task.QPCR_PROBE, default: 22}],
    default: null,
  },
  SIZE_PROBE_MAX: {
    label: 'PRIMER_INTERNAL_MAX_SIZE',
    type: ParameterType.NUMBER,
    tasks: [{task: Task.QPCR_PROBE, default: 26}],
    default: null,
  },
  PRODUCT_MIN_SIZE: {
    label: 'PRIMER_PRODUCT_MIN_SIZE',
    tasks: [
      {task: Task.QPCR_PROBE, default: 75},
      {task: Task.QPCR_DYES, default: 75},
      {task: Task.PCR, default: 200},
    ],
    type: ParameterType.NUMBER,
    default: null,
  },
  PRODUCT_MAX_SIZE: {
    label: 'PRIMER_PRODUCT_MAX_SIZE',
    type: ParameterType.NUMBER,
    tasks: [
      {task: Task.QPCR_PROBE, default: 150},
      {task: Task.QPCR_DYES, default: 150},
      {task: Task.PCR, default: 1000},
    ],
    default: null,
  },
  PRODUCT_OPT_SIZE: {
    label: 'PRIMER_PRODUCT_OPT_SIZE',
    type: ParameterType.NUMBER,
    tasks: [
      {task: Task.QPCR_PROBE, default: 100},
      {task: Task.QPCR_DYES, default: 100},
    ],
    default: null,
  },
  MIN_3_PRIME_OVERLAP: {
    label: 'PRIMER_MIN_3_PRIME_OVERLAP_OF_JUNCTION',
    default: 4,
    type: ParameterType.NUMBER,
    tasks: [
      {task: Task.QPCR_PROBE, default: null},
      {task: Task.QPCR_DYES, default: null},
      {task: Task.PCR, default: null},
    ],
  },
  MIN_5_PRIME_OVERLAP: {
    label: 'PRIMER_MIN_5_PRIME_OVERLAP_OF_JUNCTION',
    default: 7,
    type: ParameterType.NUMBER,
    tasks: [
      {task: Task.QPCR_PROBE, default: null},
      {task: Task.QPCR_DYES, default: null},
      {task: Task.PCR, default: null},
    ],
  },
  OVERLAP_JXN_LIST: {
    label: 'SEQUENCE_OVERLAP_JUNCTION_LIST',
    type: ParameterType.INDEX_LIST,
    tasks: [
      {task: Task.QPCR_PROBE, default: null},
      {task: Task.QPCR_DYES, default: null},
      {task: Task.PCR, default: null},
    ],
    default: null,
  },
  FORCE_FORWARD_START: {
    label: 'SEQUENCE_FORCE_LEFT_START',
    type: ParameterType.NUMBER,
    tasks: [
      {task: Task.QPCR_PROBE, default: null},
      {task: Task.QPCR_DYES, default: null},
      {task: Task.PCR, default: null},
    ],
    default: null,
  },
  FORCE_FORWARD_END: {
    label: 'SEQUENCE_FORCE_LEFT_END',
    type: ParameterType.NUMBER,
    tasks: [
      {task: Task.QPCR_PROBE, default: null},
      {task: Task.QPCR_DYES, default: null},
      {task: Task.PCR, default: null},
    ],
    default: null,
  },
  FORCE_REVERSE_START: {
    label: 'SEQUENCE_FORCE_RIGHT_START',
    type: ParameterType.NUMBER,
    tasks: [
      {task: Task.QPCR_PROBE, default: null},
      {task: Task.QPCR_DYES, default: null},
      {task: Task.PCR, default: null},
    ],
    default: null,
  },
  FORCE_REVERSE_END: {
    label: 'SEQUENCE_FORCE_RIGHT_END',
    type: ParameterType.NUMBER,
    tasks: [
      {task: Task.QPCR_PROBE, default: null},
      {task: Task.QPCR_DYES, default: null},
      {task: Task.PCR, default: null},
    ],
    default: null,
  },
  FORWARD_PRIMER_SEQUENCE: {
    label: 'SEQUENCE_PRIMER',
    type: ParameterType.TEXT,
    tasks: [
      {task: Task.QPCR_PROBE, default: null},
      {task: Task.QPCR_DYES, default: null},
      {task: Task.PCR, default: null},
    ],
    default: null,
  },
  REVERSE_PRIMER_SEQUENCE: {
    label: 'SEQUENCE_PRIMER_REVCOMP',
    type: ParameterType.TEXT,
    tasks: [
      {task: Task.QPCR_PROBE, default: null},
      {task: Task.QPCR_DYES, default: null},
      {task: Task.PCR, default: null},
    ],
    default: null,
  },
  INTERNAL_OLIGO_SEQUENCE: {
    label: 'SEQUENCE_INTERAL_OLIGO',
    type: ParameterType.TEXT,
    tasks: [{task: Task.QPCR_PROBE, default: null}],
    default: null,
  },
  SEQUENCING_SPACING: {
    label: 'PRIMER_SEQUENCING_SPACING',
    default: 500,
    type: ParameterType.NUMBER,
    tasks: [{task: Task.SEQUENCING, default: null}],
  },
  SEQUENCING_INTERVAL: {
    label: 'PRIMER_SEQUENCING_INTERVAL',
    default: 250,
    type: ParameterType.NUMBER,
    tasks: [{task: Task.SEQUENCING, default: null}],
  },
  SEQUENCING_LEAD: {
    label: 'PRIMER_SEQUENCING_LEAD',
    default: 50,
    type: ParameterType.NUMBER,
    tasks: [{task: Task.SEQUENCING, default: null}],
  },
  SEQUENCING_ACCURACY: {
    label: 'PRIMER_SEQUENCING_ACCURACY',
    default: 20,
    type: ParameterType.NUMBER,
    tasks: [{task: Task.SEQUENCING, default: null}],
  },
  NUM_RESULTS: {
    label: 'PRIMER_NUM_RETURN',
    default: 5,
    type: ParameterType.NUMBER,
  },
};

export default Object.freeze(PRIMER_WIZARD_PARAMS);
